import aquarium from './Aquarium.png';
import balloon from './Balloon.png';
import birthdayGirl from './BirthdayGirl.png';
import bonusGirl from './BonusGirl.png';
import finishZero from './FinishZero.png';
import gorilla from './Gorilla.png';
import heartGirl from './HeartGirl.png';
import moneymanGirl from './MoneymanGirl.png';
import rockStars from './RockStars.png';
import tourists from './Tourists.png';
import webbankirGirl from './WebbankirGirl.png';
import yourInvestor from './YourInvestor.png';

export const images = {
  aquarium,
  balloon,
  birthdayGirl,
  bonusGirl,
  finishZero,
  gorilla,
  heartGirl,
  moneymanGirl,
  rockStars,
  tourists,
  webbankirGirl,
  yourInvestor,
} as const;
